import { render, staticRenderFns } from "./VoteDetailDialog.vue?vue&type=template&id=243d38d6&scoped=true"
import script from "./VoteDetailDialog.vue?vue&type=script&lang=js"
export * from "./VoteDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./VoteDetailDialog.vue?vue&type=style&index=0&id=243d38d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d38d6",
  null
  
)

export default component.exports